import DOMDimensions from 'dom-dimensions'

/**
 * Given an element and an array of sizes,
 * apply the largest possible size to fit
 * element into parent container.
 *
 * fittext(el, ['48px', '32px', '16px'])
 * @return: { index, size }
 */

export default function (el, sizes = ['16px']) {
  const max_index = sizes.length - 1
  const parent = el.parentNode

  // get parent inner width/height (+ lil buffer)
  const dimensions = new DOMDimensions(parent)
  const max_y = dimensions.height() + 2
  const max_x = dimensions.width() + 2

  // start size at largest
  let index = 0
  el.style.fontSize = sizes[index]

  // decrement index until width fits
  if (el.scrollWidth > max_x) {
    while (el.scrollWidth > max_x && index < max_index){
      index++
      el.style.fontSize = sizes[index]
    }
  }

  // decrement index until height fits
  if (el.clientHeight > max_y) {
    while (el.clientHeight > max_y && index < max_index){
      index++
      el.style.fontSize = sizes[index]
    }
  }

  // return index and size
  return {
    index,
    size: sizes[index]
  }
}